module.exports = __webpack_public_path__ + "media/images/app/occasions/date-night-faa812f2576cafa62c970ebac5b135e6.webp";